import { useEffect, useState } from 'react';
import region_prices from './region_pricing.json';
import provider_grd from './provider_grd.json';

export type RegionPriceType = {
  postcode: number;
  name: string;
  provider: string;
  price_cons: number;
  price_inject: number;
  subside: number;
  provider_grd?: number;
};

const getProviderGrd = (provider: string): number =>
  provider_grd.find((item) => item.provider === provider)?.value || 0;

const getRegionDetail = (postCode: string): RegionPriceType => {
  const defaultRegionPrice = { ...region_prices[0] } as RegionPriceType;
  const details = region_prices.find(
    (region) => region.postcode.toString() === postCode
  );

  // add provider prime info if we find the correct postcode region price
  if (details) {
    (details as RegionPriceType).provider_grd = getProviderGrd(
      details.provider
    );
    return { ...defaultRegionPrice, ...details };
  }

  return defaultRegionPrice;
};

const useGetRegionPrice = (postCode: string | undefined) => {
  const [regionPriceDetail, setRegionPriceDetail] = useState<
    RegionPriceType | undefined
  >(undefined);

  useEffect(() => {
    if (postCode) {
      const regionDetail = getRegionDetail(postCode);
      console.log(
        `region price (postcode:${postCode}): ${JSON.stringify(regionDetail)}`
      );
      setRegionPriceDetail(regionDetail);
    }
  }, [postCode]);

  return regionPriceDetail;
};

export default useGetRegionPrice;
